export default "__VITE_PUBLIC_ASSET__231dbbe4__"